import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import TextEditor from "./TextEditor";
import { getContaint, setContaint } from "./ArticleContent";
import api from "./Api";

const ArticleEditor = ({
  articleData = {}, setIsWriting, isEditing = false,
}) => {
  const [article, setArticle] = useState({
    id:0,
    title: "",
    category: "",
    coverImage: null,
    author: Cookies.get("username") || "",
    authorName: Cookies.get("name") || "",
    publishDate: new Date().toISOString().split("T")[0],
    tags: "",
    seoTitle: "",
    description: "",
    content: "",
    artLang: "en",
    artCategory: "Other",
    ...articleData, // Merge initial data if editing
  });
  const [isPreview, setIsPreview] = useState(false);
  const [autoSaveStatus, setAutoSaveStatus] = useState("");

useEffect(() => {
    if (articleData.tags && Array.isArray(articleData.tags)) {
        setArticle((prevArticle) => ({
            ...prevArticle,
            tags: articleData.tags.join(", "),
        }));
        setContaint(articleData.content)
    }
}, [articleData]);

  // Auto-save every 60 seconds
  useEffect(() => {
    const timer = setInterval(async () => {
      setAutoSaveStatus("Auto-saving...");
      await handleSaveDraft(true);
      setAutoSaveStatus("Auto-saved ✓");
      setTimeout(() => setAutoSaveStatus(""), 3000);
    }, 60000);
    return () => clearInterval(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [article]);

  const handleSaveDraft = async (silent = false) => {
    const draftData = {
      id:article.id,
      title: article.title,
      category: article.category,
      author: article.author,
      authorName: article.authorName,
      publishDate: article.publishDate,
      description: article.description,
      tags:  article.tags ? article.tags.split(',').map(tag => tag.trim()) : [],
      content: getContaint(),
      artLng: article.artLang,
      artCategory: article.artCategory,
    };
    
    const formData = new FormData();
    formData.append(
      "blog",
      new Blob([JSON.stringify(draftData)], { type: "application/json" })
    );
    if (article.coverImage) {
      formData.append("coverImage", article.coverImage);
    }

    try {
      const resp = await api.post("/blogs/draft", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (resp !== undefined && resp !== null && !silent) {
        alert("Draft Saved");
        setIsWriting(false);
      }
    } catch (error) {
      if (!silent) {
        if (error.response && error.response.data) {
          console.error("Error details:", error.response.data);
          alert(`${error.response.data}`);
        } else {
          console.error("Error:", error);
          alert("An unexpected error occurred. Please try again.");
        }
      } else {
        console.error("Auto-save error:", error);
      }
    }
  };


  const handleUpdate = async () => {
    const updatedData = {
      id: article.id,
      title: article.title,
      category: article.category,
      tags: article.tags ? article.tags.split(',').map(tag => tag.trim()) : [],
      content: getContaint(),
    };

    try {
      const resp = await api.put(`/blogs/${article.id}`, updatedData);
      if (resp && resp?.id) {
      alert("Article Updated");
      setIsWriting(false);
      }
    } catch (error) {
      if (error.response && error.response.data) {
      console.error("Error details:", error.response.data);
      alert(`${error.response.data}`);
      } else {
      console.error("Error:", error);
      alert("An unexpected error occurred. Please try again.");
      }
    }
    };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setArticle({ ...article, [name]: value });
  };

  const handleContentChange = (content) => {
    setArticle({ ...article, content });
  };

  const handleCoverImageUpload = (event) => {
    setArticle({ ...article, coverImage: event.target.files[0] });
  };

  const handleCancel=async () => {
    if (window.confirm("Are you sure you want to cancel? You will lose any unsaved changes.")) {
      setIsWriting(false);
    }
  }

  const handleDelete=async () => {
    if (window.confirm("Are you sure you want to Delete? You will be not able to resotre once delete")) {
      const response = await api.delete("/blogs/delete?id="+articleData.id);
      console.log("Article Deleted successfully", response);
      alert("Article Deleted Successfully");
      setIsWriting(false);
    }
  }
    const handlePublish = async (id) => {
      if(articleData.id && articleData.id>0){
        try {
          const response = await api.post("/blogs/publish?id="+articleData.id);
          console.log("Article published successfully", response);
          alert("Article Published Successfully");
          setIsWriting(false);
        } catch (error) {
          console.error("Error publishing article", error);
          alert("Failed to publish article");
        }
      }
    
    };

  return (
    <div className="article-editor p-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2>{articleData.id ? "Edit Article" : "Write New Article"}</h2>
        <div className="d-flex align-items-center gap-2">
          {autoSaveStatus && <small className="text-muted">{autoSaveStatus}</small>}
          <button className="btn btn-outline-secondary btn-sm" onClick={() => setIsPreview(true)}>
            👁 Preview
          </button>
        </div>
      </div>

      <label>Title</label>
      <input
        type="text"
        name="title"
        className="form-control mb-3"
        value={article.title}
        onChange={handleChange}
      />

      <label>Category</label>
      <select
        name="category"
        className="form-control mb-3"
        value={article.category}
        onChange={handleChange}
      >
        <option value="">Select Category</option>
        <option value="Tech">Tech</option>
        <option value="Health">Health</option>
        <option value="Business">Business</option>
        <option value="Lifestyle">Lifestyle</option>
        <option value="Self-Development">Self-Development</option>
        <option value="Personal Growth">Personal Growth</option>
        <option value="Mindfulness">Mindfulness</option>
        <option value="Self-Control">Self-Control</option>
        <option value="Ethics">Ethics</option>
        <option value="Character Building">Character Building</option>
        <option value="Life Philosophy">Life Philosophy</option>
        <option value="Emotional Intelligence">Emotional Intelligence</option>
        <option value="Spirituality">Spirituality</option>
        <option value="Inner Peace">Inner Peace</option>
        <option value="Motivation">Motivation</option>
        <option value="Inspiration">Inspiration</option>
        <option value="Mental Health">Mental Health</option>
        <option value="Well-being">Well-being</option>
        <option value="Leadership">Leadership</option>
        <option value="Integrity">Integrity</option>
        <option value="Behavioral Psychology">Behavioral Psychology</option>
        <option value="Positive Thinking">Positive Thinking</option>
        <option value="Self-Awareness">Self-Awareness</option>
        <option value="Values & Morals">Values & Morals</option>
        <option value="Conscious Living">Conscious Living</option>
        <option value="Resilience">Resilience</option>
        <option value="Discipline">Discipline</option>
        <option value="Humility">Humility</option>
        <option value="Gratitude">Gratitude</option>
        <option value="Consistency">Consistency</option>
        <option value="Authenticity">Authenticity</option>
        <option value="Self-Mastery">Self-Mastery</option>
        <option value="Emotional Balance">Emotional Balance</option>
        <option value="Wisdom">Wisdom</option>
        <option value="Personal Responsibility">Personal Responsibility</option>
      </select>

      <label>Cover Image</label>
      <input type="file" className="form-control mb-3" onChange={handleCoverImageUpload} />
      <label>Tags (comma-separated)</label>
      <input
        type="text"
        name="tags"
        className="form-control mb-3"
        value={article.tags}
        onChange={handleChange}
      />
      <label>description</label>
      <input
        type="text"
        name="description"
        className="form-control mb-3"
        value={article.description}
        onChange={handleChange}
      />
      // article artLang arnd artCategory
      <label>Article Language</label>
      <select
        name="artLang"
        className="form-control mb-3"
        value={article.artLang}
        onChange={handleChange}
      >
        <option value="en">English</option>
        <option value="Marathi">Marathi</option>
      </select>
      <label>Article Category</label>
      <select
        name="artCategory"
        className="form-control mb-3"
        value={article.artCategory}
        onChange={handleChange}
      >
        <option value="Other">Other</option>
        <option value="Tech">Tech</option>
        <option value="Motivational">Motivational</option>
        </select>

      <label>Article Content</label>
      <TextEditor  value={article.content} onChange={handleContentChange} />

      <div className="article-actions d-flex justify-content-between">
        <button className="btn btn-secondary" onClick={() => handleSaveDraft(false)}>Save Draft</button>
       
        {articleData.id && (<>
        <button className="btn btn-success" onClick={handlePublish}>Publish</button>
          <button className="btn btn-danger" onClick={handleDelete} >Delete</button>
          {isEditing && (
            <button className="btn btn-primary" onClick={handleUpdate}>
              Update
            </button>
          )}
          </>
        )}
         <button className="btn btn-secondary" onClick={handleCancel}>Cancel</button>
       
      </div>

      {/* Preview Modal */}
      {isPreview && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
          zIndex: 9999, overflowY: 'auto', padding: '20px'
        }}>
          <div style={{
            maxWidth: 860, margin: '0 auto', background: 'var(--card-bg, #fff)',
            color: 'var(--text-color, #222)', borderRadius: 12, padding: 32
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
              <h2>{article.title || 'Untitled'}</h2>
              <button className="btn btn-secondary btn-sm" onClick={() => setIsPreview(false)}>✕ Close</button>
            </div>
            {article.description && <p style={{ color: 'var(--muted-color,#666)', fontStyle: 'italic' }}>{article.description}</p>}
            <hr />
            <div
              className="article-content"
              dangerouslySetInnerHTML={{ __html: getContaint() || article.content }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ArticleEditor;
